import Table from "../../../layouts/seller-hub/Table";

const Overview = () => {
  return (
    <Table>
      <div className="md:w-1/2">
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Name
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Size
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Description
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Price
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Availability status
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Brand
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Gender
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Category
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Item status
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Discount
        </div>
      </div>
      <div className="md:w-1/2">
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Kimono Japan
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">16</div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          It is one time, bought in the uk, has a little tear
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          ₦20,000
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Available
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Tokyo
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Male
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Dress
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          None
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          #20,000
        </div>
      </div>
    </Table>
  );
};

export default Overview;
